import { render, staticRenderFns } from "./CPeriodStatusIcon.vue?vue&type=template&id=f83d51a0"
import script from "./CPeriodStatusIcon.vue?vue&type=script&lang=ts"
export * from "./CPeriodStatusIcon.vue?vue&type=script&lang=ts"
import style0 from "./CPeriodStatusIcon.vue?vue&type=style&index=0&id=f83d51a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@8.0.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack_3967ed8cd784b60b7f0fd1a71945913e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports